import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {DataTableModule} from "../../components/common/datatables/datatable.module";
import {PipesModule} from "../../pipes/pipes.module";
import {ClientStatusModule} from "../client-status/client-status.module";
import {ClientsService} from "../../models/clients/clients.service";
import {IncompleteComponent} from "./incomplete.component";

@NgModule({
    declarations: [
        IncompleteComponent,
    ],
    imports: [
        CommonModule,
        DataTableModule,
        PipesModule,
        ClientStatusModule,
    ],
    exports: [
        IncompleteComponent,
    ],
    providers: [
        ClientsService,
    ]
})

export class IncompleteModule {
}

 


// WEBPACK FOOTER //
// ./src/app/modules/incomplete/incomplete.module.ts